import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosCall, AxiosPost, AxiosDelete } from '../../../utils/axios';
import * as actions from './apiKeyActions';

// ----------------------------------------------------------------------
// Worker Sagas

// Fetch API Keys List
function* fetchApiKeys(action) {
  try {
    const { organizationId } = action.payload;
    let url = '/mycore/api-keys/list/';
    if (organizationId) {
      url += `?organization_id=${organizationId}`;
    }

    const result = yield call(AxiosCall, url);
    yield put(actions.fetchApiKeysSuccess(result.data));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message;
    yield put(actions.fetchApiKeysFailure(errorMessage));
  }
}

// Fetch API Key Detail
function* fetchApiKeyDetail(action) {
  try {
    const { apiKeyId } = action.payload;
    const result = yield call(AxiosCall, `/mycore/api-keys/${apiKeyId}/detail/`);
    yield put(actions.fetchApiKeyDetailSuccess(result.data));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message;
    yield put(actions.fetchApiKeyDetailFailure(errorMessage));
  }
}

// Create API Key
function* createApiKey(action) {
  try {
    const result = yield call(AxiosPost, '/mycore/api-keys/create/', action.payload);
    yield put(actions.createApiKeySuccess(result.data));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message;
    yield put(actions.createApiKeyFailure(errorMessage));
  }
}

// Revoke API Key
function* revokeApiKey(action) {
  try {
    const { apiKeyId } = action.payload;
    yield call(AxiosPost, `/mycore/api-keys/${apiKeyId}/revoke/`, {});
    yield put(actions.revokeApiKeySuccess(apiKeyId));
    // Optionally refetch the list
    yield put(actions.fetchApiKeysRequest());
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message;
    yield put(actions.revokeApiKeyFailure(errorMessage));
  }
}

// Reactivate API Key
function* reactivateApiKey(action) {
  try {
    const { apiKeyId } = action.payload;
    yield call(AxiosPost, `/mycore/api-keys/${apiKeyId}/reactivate/`, {});
    yield put(actions.reactivateApiKeySuccess(apiKeyId));
    // Optionally refetch the list
    yield put(actions.fetchApiKeysRequest());
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message;
    yield put(actions.reactivateApiKeyFailure(errorMessage));
  }
}

// Delete API Key
function* deleteApiKey(action) {
  try {
    const { apiKeyId } = action.payload;
    yield call(AxiosDelete, `/mycore/api-keys/${apiKeyId}/delete/`);
    yield put(actions.deleteApiKeySuccess(apiKeyId));
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message;
    yield put(actions.deleteApiKeyFailure(errorMessage));
  }
}

// ----------------------------------------------------------------------
// Watcher Saga

export default function* apiKeySaga() {
  yield takeLatest(actions.FETCH_API_KEYS.REQUEST, fetchApiKeys);
  yield takeLatest(actions.FETCH_API_KEY_DETAIL.REQUEST, fetchApiKeyDetail);
  yield takeLatest(actions.CREATE_API_KEY.REQUEST, createApiKey);
  yield takeLatest(actions.REVOKE_API_KEY.REQUEST, revokeApiKey);
  yield takeLatest(actions.REACTIVATE_API_KEY.REQUEST, reactivateApiKey);
  yield takeLatest(actions.DELETE_API_KEY.REQUEST, deleteApiKey);
}
